
import {
  type CountryOfOrigin
} from 'types'

import i18n from '../../i18next'

import { mainSplitApi } from './redux/mainSplitApi'

export const countryApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCountryOfOrigins: builder.query<CountryOfOrigin[], void>({
      query: () => {
        return {
          url: '/countries',
          method: 'GET'
        }
      },
      transformResponse: (response: CountryOfOrigin[]) => {
        return response.map(country => ({
          ...country,
          fullName: i18n.t(`countries.${country.countryCode}`, { defaultValue: country.fullName })
        }))
      }
    })
  }),
  overrideExisting: false
})

export const { useFetchCountryOfOriginsQuery } = countryApi
